/* eslint-disable no-unneeded-ternary */
/* eslint-disable react/prop-types */
import { Box, Button, Grid, TextField, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import { Autocomplete } from '@material-ui/lab';
// eslint-disable-next-line import/extensions
import { endOfMonth, format, startOfMonth } from 'date-fns';
import filterStyles from '../filterStyles';
import useApp from '../../hooks/useApp';

const Filter = ({ filters, setFilters }) => {
  const classes = filterStyles();

  const { brokers } = useApp();

  const [currentFilters, setCurrentFilters] = useState({
    date_start: format(startOfMonth(new Date()), 'Y-MM-dd'),
    date_end: format(endOfMonth(new Date()), 'Y-MM-dd'),
    broker_id: '',
  });

  const handleChange = (e) => {
    e.preventDefault();

    const { name, value } = e.target;

    setCurrentFilters({
      ...currentFilters,
      [name]: value,
    });
  };

  const handleFilter = () => {
    setFilters({
      ...filters,
      ...currentFilters,
    });
  };

  return (
    <Box className={classes.boxFilter}>
      <Grid container spacing={2} alignItems="center">
        <Grid container item xs={12} md={12} alignItems="center" spacing={2}>
          <Grid container item spacing={2} alignItems="flex-end">
            <Grid
              item
              xs={3}
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '4px',
                color: 'GrayText',
              }}>
              <Typography>Data Inicial: </Typography>
              <TextField
                className={classes.inputDate}
                type="date"
                name="date_start"
                placeholder="Data Inicial"
                value={currentFilters.date_start}
                onChange={handleChange}
              />
            </Grid>
            <Grid
              item
              xs={3}
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '4px',
                color: 'GrayText',
              }}>
              <Typography>Data Final: </Typography>
              <TextField
                className={classes.inputDate}
                type="date"
                name="date_end"
                placeholder="Data Inicial"
                value={currentFilters.date_end}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <Autocomplete
                className={classes.inputSelect}
                multiple
                options={brokers || []}
                getOptionLabel={(option) => option?.name}
                onChange={(e, value) =>
                  setCurrentFilters({ ...currentFilters, broker_id: value?.map((broker) => broker?.id) })
                }
                renderInput={(params) => (
                  <TextField {...params} className="autocomplete" variant="standard" placeholder="Corretor" />
                )}
              />
            </Grid>

            <Grid item>
              <Button fullWidth className={classes.button} onClick={handleFilter}>
                Filtrar
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Filter;
